module.exports = __webpack_public_path__ + "img/usb.8be46dac.svg";